import { AccountsAPI } from "./axios.config";

export const editPosting = (transactionNo, data) =>
    AccountsAPI.patch(`/postings/${transactionNo}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const reversePosting = (transactionNo, data) =>
    AccountsAPI.request({
        url: `/postings/${transactionNo}`,
        method: "DELETE",
        data: JSON.stringify({ data }),
        headers: { "Content-Type": "application/json" },
    });

export const disputePosting = (transactionNo, data) =>
    AccountsAPI.patch(`/postings/${transactionNo}/disputed`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const getCurrentSessionTransactionPeriod = (sessionPeriod) =>
    AccountsAPI.get(`/TransactionPeriods/Current?sessionPeriod=${sessionPeriod}`);

export const getDefaultNominals = (branchId) => AccountsAPI.get(`/DefaultNominal/${branchId}`);

export const getNewDefaultNominals = (branchId) =>
    AccountsAPI.get(`/DefaultNominal/${branchId}/New`);

export const getAuthorizations = () => AccountsAPI.get(`/Authorisations`);

export const updateAuthoriations = (data) =>
    AccountsAPI.patch(`/Authorisations`, JSON.stringify({ data: data }), {
        headers: { "Content-Type": "application/json" },
    });

export const updateDefaultNominals = (branchId, data) =>
    AccountsAPI.post(`/DefaultNominal/${branchId}`, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
    });

export const getReportTemplates = (type) => AccountsAPI.get(`/ReportTemplates?reportType=${type}`);

export const addReportTemplate = (data, type) =>
    AccountsAPI.post(`/ReportTemplates?reportType=${type}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const editReportTemplate = (data, type, id) =>
    AccountsAPI.patch(`/ReportTemplates/${id}?reportType=${type}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const getPreviousTransactions = (
    matterId,
    nominalRef,
    supplierRef,
    page = 1,
    limit = 200,
    { ledgerPostingType, currencyCode } = {},
) => {
    let url = `/PreviousTransactions?`;

    url += `page=${page}&limit=${limit}`;

    if (matterId) {
        url += `&MatterID=${matterId}`;
    }
    if (nominalRef) {
        url += `&nominalRef=${nominalRef}`;
    }
    if (supplierRef) {
        url += `&supplierRef=${supplierRef}`;
    }
    if (ledgerPostingType) {
        url += `&LedgerPostingType=${encodeURIComponent(ledgerPostingType)}`;
    }
    if (currencyCode) {
        url += `&CurrencyCode=${encodeURIComponent(currencyCode)}`;
    }

    return AccountsAPI.get(url);
};

export const getChartOfAccounts = () => AccountsAPI.get(`/ChartOfAccounts`);

export const getChartOfAccountsBasic = () => AccountsAPI.get(`/ChartOfAccounts/basic`);

export const getChartOfAccountById = (id) => AccountsAPI.get(`/ChartOfAccounts/${id}`);

export const createChartOfAccounts = (data) =>
    AccountsAPI.post(`/ChartOfAccounts`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const updateChartOfAccounts = (id, data) =>
    AccountsAPI.patch(`/ChartOfAccounts/${id}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const getChartOfAccountBalance = (type) =>
    AccountsAPI.get(
        `/ChartOfAccounts?type=${type}&active=true&fields=chartOfAccountId,name,type&orderby=name`,
    );

export const getBankRecData = (nominlaId, reconcile) =>
    AccountsAPI.get(`/bankrec/${nominlaId}?todate=${reconcile}`);

export const getBankRecsByNominal = (nominalRef) =>
    AccountsAPI.get(`/BankRec?active=true&NominalRef=${nominalRef}`);

export const addBankRecs = (nominalRef, data) =>
    AccountsAPI.post(`/bankrec/${nominalRef}/save`, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
    });

export const postBankRecs = (nominalRef, data) =>
    AccountsAPI.post(`/bankrec/${nominalRef}`, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
    });

export const AuthorizeChits = (data) =>
    AccountsAPI.post(`/Chits/Authorise`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const getBankRec = (subtype) => {
    const url = subtype ? `/BankRec?active=true&subtype=${subtype}` : `/BankRec?active=true`;
    return AccountsAPI.get(url);
};

export const getBankRecNominals = () =>
    AccountsAPI.get(`/nominals?active=true&orderBy=subType,nominalRef`);

export const getactiveVats = () => AccountsAPI.get(`/VatCodes?active=true`);

export const getVatcodes = (page, limit) =>
    AccountsAPI.get(`/VatCodes?page=${page}&limit=${limit}`);

export const addnewVat = (data) =>
    AccountsAPI.post(`/VatCodes`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const editVatinfo = (id, data) =>
    AccountsAPI.patch(`/VatCodes/${id}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const createposting = (data, options = {}) => {
    const { allowOverdrawn = false, authcode } = options;
    let url = `/Postings`;
    const qp = [];
    if (allowOverdrawn) qp.push(`allowOverdrawn=true`);
    if (authcode) qp.push(`authcode=${encodeURIComponent(authcode)}`);
    if (qp.length) url += `?${qp.join("&")}`;
    return AccountsAPI.post(url, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });
};

export const createChitRequest = (data) =>
    AccountsAPI.post(`/Chits`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const getChitRequest = (id) => AccountsAPI.get(`/Chits/${id}`);

export const updateChitRequest = (id, data) =>
    AccountsAPI.patch(`/Chits/${id}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json-patch+json" },
    });

export const getChitDocuments = (chitId) => AccountsAPI.get(`/Chits/${chitId}/Documents`);

export const rejectChitRequest = (id, data) =>
    AccountsAPI.patch(`/Chits/${id}/Reject`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const getConsultantRefs = () => AccountsAPI.get(`/Suppliers?type=Consultant&active=true`);

export const getDisbursementMatterList = (matterId) =>
    AccountsAPI.get(`/Postings/Matters/${matterId}/UnpaidDisb`);

export const getPaySupplierList = (supplierId, transactionType, type) => {
    let url = `/Postings/Supplier/${supplierId}/UnpaidDisb`;
    const queryParams = new URLSearchParams();

    if (transactionType) {
        queryParams.append("transactiontype", transactionType);
    }
    if (type) {
        queryParams.append("type", type);
    }

    const qs = queryParams.toString();
    if (qs) {
        url += `?${qs}`;
    }

    return AccountsAPI.get(url);
};

export const getPaymentRunList = () =>
    AccountsAPI.get(`/PaymentRun?active=true`);

export const getPaymentRun = (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.MatterId) queryParams.append("MatterId", params.MatterId);
    if (params.SupplierRef) queryParams.append("SupplierRef", params.SupplierRef);
    if (params.FromDate) queryParams.append("FromDate", params.FromDate);
    if (params.ToDate) queryParams.append("ToDate", params.ToDate);
    if (params.OnlyDueInvoices !== undefined) {
        queryParams.append("OnlyDueInvoices", params.OnlyDueInvoices);
    }
    if (params.IncludeSuppliersOnHold !== undefined) {
        queryParams.append("IncludeSuppliersOnHold", params.IncludeSuppliersOnHold);
    }
    if (params.TransactionType !== undefined && params.TransactionType !== null) {
        queryParams.append("TransactionType", params.TransactionType);
    }
    if (params.Page) queryParams.append("Page", params.Page);
    if (params.Limit) queryParams.append("Limit", params.Limit);
    if (params.OrderBy) queryParams.append("OrderBy", params.OrderBy);

    const qs = queryParams.toString();
    const url = qs ? `/Postings/PaymentRun?${qs}` : `/Postings/PaymentRun`;
    return AccountsAPI.get(url);
};

export const postPaymentRun = (data) =>
    AccountsAPI.post(`/Postings/PaymentRun`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const getMatterDisbRecords = (matterId) =>
    AccountsAPI.get(`/Postings/Matters/${matterId}/UnbilledDisb?billed=false&InBillRequest=false`);

export const getPostingDocuments = (transcNo) => AccountsAPI.get(`/Postings/${transcNo}/Documents`);

export const addPostingDocuments = (transNo, data) =>
    AccountsAPI.post(`/postings/${transNo}/Documents`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const updatePostingDocuments = (transNo, data) =>
    AccountsAPI.patch(`/postings/${transNo}/Documents`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const deleteSaleAllocation = (transNo, allocationId) =>
    AccountsAPI.delete(`/postings/${transNo}/SaleAllocation/${allocationId}`);

export const getDashboardDebtorsData = (teamId, feeEarnerRef, branchId, fromDate, toDate) => {
    let url = `/Dashboard/Debtors?`;
    const parameters = constructApiQuery(branchId || null, teamId || null, feeEarnerRef || null);

    if (fromDate) {
        url += `&FromDate=${fromDate}`;
    }
    if (toDate) {
        url += `&ToDate=${toDate}`;
    }

    if (Object.keys(parameters).length) {
        url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
    }
    return AccountsAPI.get(url);
};

export const getDashboardCreditorsData = (teamId, feeEarnerRef, branchId, fromDate, toDate) => {
    let url = `/Dashboard/Creditors?`;
    const parameters = constructApiQuery(branchId || null, teamId || null, feeEarnerRef || null);

    if (fromDate) {
        url += `&FromDate=${fromDate}`;
    }
    if (toDate) {
        url += `&ToDate=${toDate}`;
    }

    if (Object.keys(parameters).length) {
        url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
    }
    return AccountsAPI.get(url);
};

export const getDashboardBillingTargetData = (teamId, feeEarnerRef, branchId, fromDate, toDate) => {
    let url = `/Dashboard/BillingTarget?`;
    const parameters = constructApiQuery(branchId || null, teamId || null, feeEarnerRef || null);

    if (fromDate) {
        url += `&FromDate=${fromDate}`;
    }
    if (toDate) {
        url += `&ToDate=${toDate}`;
    }

    if (Object.keys(parameters).length) {
        url += `&${Object.keys(parameters)[0]}=${Object.values(parameters)[0]}`;
    }
    return AccountsAPI.get(url);
};

export const importSampleChit = () => AccountsAPI.get(`/Chits/Import`);

export const getChitImportTypes = (active = true, orderby = "importerName") =>
    AccountsAPI.get(`/Chits/import/types?active=${active}&orderby=${orderby}`);

export const getChitImportData = (chitImporterId) =>
    AccountsAPI.get(`/Chits/import/data?chitImporterId=${chitImporterId}`);

export function constructApiQuery(branch, team, feeEarner) {
    let query = {};
    if (feeEarner && feeEarner !== "ALL") {
        query.FeeEarnerRef = feeEarner;
    } else if (team && team !== -2) {
        query.TeamID = team;
    } else if (branch && branch > 0) {
        query.BranchId = branch;
    }

    return query;
}

export const getLookups = (lookupType) => AccountsAPI.get(`/Lookups/${lookupType}`);

export const getLookupById = (lookupType, id) => AccountsAPI.get(`/Lookups/${lookupType}/${id}`);

export const getTransactionSearchList = (page, limit, parameter, filterParameters, searchValue) => {
    let url = `/postings/search?`;
    const params = [];

    if (page) {
        params.push(`page=${page}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (parameter) {
        params.push(`orderBy=${parameter}`);
    }
    if (searchValue) {
        params.push(`searchText=${encodeURIComponent(searchValue)}`);
    }
    if (filterParameters?.matterId) {
        params.push(`matterId=${filterParameters.matterId}`);
    }
    if (filterParameters?.supplierRef) {
        params.push(`supplierRef=${encodeURIComponent(filterParameters.supplierRef)}`);
    }
    if (filterParameters?.nominalRef) {
        params.push(`nominalRef=${encodeURIComponent(filterParameters.nominalRef)}`);
    }
    if (filterParameters?.fromDate) {
        params.push(`fromDate=${filterParameters.fromDate}`);
    }
    if (filterParameters?.toDate) {
        params.push(`toDate=${filterParameters.toDate}`);
    }

    url += params.join("&");
    return AccountsAPI.get(url);
};

export const createLookup = (lookupType, data) =>
    AccountsAPI.post(`/Lookups/${lookupType}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const updateLookup = (lookupType, id, data) =>
    AccountsAPI.patch(`/Lookups/${lookupType}/${id}`, JSON.stringify({ data }), {
        headers: { "Content-Type": "application/json" },
    });

export const searchPostings = (date, reference, limit = 1) => {
    let url = `/postings/search?`;
    const params = [];

    if (date) {
        params.push(`date=${date}`);
    }
    if (reference) {
        params.push(`reference=${encodeURIComponent(reference)}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }

    url += params.join("&");
    return AccountsAPI.get(url);
};
